import { useState, useEffect } from 'react'
import type { FC } from 'react'
// @ts-expect-error qr.js is not typed
import qrcodeGen from 'qr.js'

//
// CP1251 Converter
//

const CP1251_MAP: Record<number, number> = {
  // А-Я (0x410 - 0x42F) -> 0xC0 - 0xDF
  // а-п (0x430 - 0x43F) -> 0xE0 - 0xEF
  // р-я (0x440 - 0x44F) -> 0xF0 - 0xFF
  // Ё (0x401) -> 0xA8
  // ё (0x451) -> 0xB8
  0x0401: 0xA8,
  0x0451: 0xB8,
  // № (0x2116) -> 0xB9
  0x2116: 0xB9,
}

// Fill ranges
for (let i = 0; i <= 31; i++) {
  CP1251_MAP[0x0410 + i] = 0xC0 + i
}
for (let i = 0; i <= 15; i++) {
  CP1251_MAP[0x0430 + i] = 0xE0 + i
}
for (let i = 0; i <= 15; i++) {
  CP1251_MAP[0x0440 + i] = 0xF0 + i
}

const toCp1251 = (str: string): string => {
  let result = ''
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i)
    if (code < 128) {
      result += String.fromCharCode(code)
    } else if (CP1251_MAP[code]) {
      result += String.fromCharCode(CP1251_MAP[code])
    } else {
      // Fallback for unknown chars (e.g. replace with space or ?)
      result += '?'
    }
  }
  return result
}


//
// Custom QR Component using qr.js directly
//

interface T_QRCodeCP1251Props {
  value: string
  size?: number
}

export const QRCodeCP1251: FC<T_QRCodeCP1251Props> = ({
  value,
  size = 256,
}) => {
  const [ cells, setCells ] = useState<boolean[][] | null>(null)

  useEffect(() => {
    try {
      const binaryString = toCp1251(value)
      const qr = qrcodeGen(binaryString, { typeNumber: -1, errorCorrectLevel: 1 }) // Level M

      const modules = qr.modules
      const count = modules.length
      const grid: boolean[][] = []

      for (let r = 0; r < count; r++) {
        const row: boolean[] = []
        for (let c = 0; c < count; c++) {
          row.push(modules[r][c])
        }
        grid.push(row)
      }
      setCells(grid)
    } catch (e) {
      console.error('QR Gen error', e)
    }
  }, [ value ])

  if (!cells) return null

  const count = cells.length


  return (
    <svg width={size} height={size} viewBox={`0 0 ${count} ${count}`}>
      <rect width={count} height={count} fill='white' />
      {cells.map((row, r) => (
        row.map((isDark, c) => (
          isDark ? (
            <rect
              key={`${r}-${c}`}
              x={c}
              y={r}
              width={1}
              height={1}
              fill='black'
            />
          ) : null
        ))
      ))}
    </svg>
  )
}
